/**
 * Created by yiren on 2019-08-26
 * Proposal Page
 */

import React from "react";
import style from "./style.css";
import Header from "../components/Header";
import { InputItem, WhiteSpace, Toast } from "antd-mobile";
import { BaseUrl } from "../config/api";
import nebulas from "nebulas";
import { getAccountState } from "../config/api";
import Loading from "../components/Loading/index";
import { getContractAddress, getFromAddress } from "../tool/lstool";
import QRCode from "qrcode.react";
import NebPay from "nebpay.js";

export default class Proposal extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      toAddress: "",
      amount: "",
      fromAddress: getFromAddress(),
      spinning: false,
      note: "",
      txString: null,
      contractAddress: getContractAddress()
    };
    this.nebPay = new NebPay();
    this.serialNumber = '';
  }

  componentDidMount() {
    console.log(BaseUrl.nas);
    // this.getAccountState();
    if (!this.state.contractAddress || !this.state.fromAddress) {
      Toast.info("请先设置合约地址以及From");
      this.props.history.push('/contract');
    }
    console.log("1111111111", process.env);
  }

  async getAccountInfo() {
    Toast.loading();
    const data = await getAccountState({
      address: this.state.fromAddress
    });
    if (data.result) {
      console.log(data.result);
      this.setState({
        accountInfo: data.result
      });
      this.generateTransaction();
    } else {
      Toast.hide();
    }
  }

  startGenerate = () => {
    this.getAccountInfo();
  };

  generateTransaction = () => {
    let param = [this.state.toAddress, this.state.amount, this.state.note];
    let paraStr = JSON.stringify(param);
    console.log("STR = " + paraStr);
    var tx = new nebulas.Transaction({
      chainID: 1,
      from: this.state.fromAddress,
      to: this.state.contractAddress,
      value: 0,
      nonce: this.state.accountInfo.nonce,
      gasPrice: 20000000000,
      gasLimit: 200000,
      contract: {
        function: "submitProposal",
        args: paraStr
      }
    });
    console.log(tx.toPlainObject());
    this.setState({
      txString: JSON.stringify(tx.toPlainObject())
    });

    Toast.hide();
    // console.log(tx.hashTransaction())
  };

  setFromAddress = e => {
    console.log(e);
    this.setState({
      fromAddress: e
    });
  };

  setAmount = e => {
    this.setState({
      amount: e
    });
  };

  setToAddress = e => {
    this.setState({
      toAddress: e
    });
  };

  setContractAddress = e => {
    this.setState({
      contractAddress: e
    });
  };

  setNote = e => {
    this.setState({
      note: e
    });
  };

  nebpayAction = () => {
    const to = `${this.state.contractAddress}`; //Dapp的合约地址
    const value = "0";
    const callFunction = "submitProposal"; //调用的函数名称
    const callArgs = `["${this.state.toAddress}","${this.state.amount}","${this.state.note}"]`; //参数格式为参数数组的JSON字符串, 比如'["arg"]','["arg1","arg2]'
    const options = {
      gasLimit: "200000", //可以自定义gasLimit和gasPrice
      //callback 是交易查询服务器地址,
      //callback: NebPay.config.mainnetUrl //在主网查询(默认值)
      callback:
          process.env.API_ENV === "prod"
              ? NebPay.config.mainnetUrl
              : NebPay.config.testnetUrl //在测试网查询
    };

    //发送交易(发起智能合约调用)
    this.serialNumber = this.nebPay.call(to, value, callFunction, callArgs, options);

    console.log(this.serialNumber);
  };

  render() {
    const params = `{"pageParams":{"pay":{"currency":"NAS","value":"0","to":"${this.state.contractAddress}","payload":{"function":"submitProposal","args":"[\\"${this.state.toAddress}\\",\\"${this.state.amount}\\",\\"${this.state.note}\\"]","type":"call"}}},"des":"confirmTransfer","category":"jump"}`;

    return (
      <div className={style.container}>
        <h2>发起提案</h2>
        <div
          style={{
            width: "100%",
            height: "1px",
            backgroundColor: "rgba(0,0,0,0.6)"
          }}
        />

        {/*<div className={style.inputContainer}>*/}
        {/*<span className={style.inputName}>Contract Address</span>*/}
        {/*<InputItem*/}
        {/*placeholder="Contract Address"*/}
        {/*className={style.proposalInput}*/}
        {/*onChange={e => this.setContractAddress(e)}*/}
        {/*/>*/}
        {/*</div>*/}

        <div className={style.inputContainer}>
          <span className={style.inputName}>To Address</span>
          <InputItem
            placeholder="To Address"
            className={style.proposalInput}
            onChange={e => this.setToAddress(e)}
          />
        </div>

        <div className={style.inputContainer}>
          <span className={style.inputName}>Amount</span>
          <InputItem
            placeholder="Amount"
            className={style.proposalInput}
            onChange={e => this.setAmount(e)}
          />
        </div>
        {/*<div className={style.inputContainer}>*/}
        {/*<span className={style.inputName}>From Address</span>*/}
        {/*<InputItem*/}
        {/*placeholder="From Address"*/}
        {/*className={style.proposalInput}*/}
        {/*onChange={e => this.setFromAddress(e)}*/}
        {/*/>*/}
        {/*</div>*/}
        <div className={style.inputContainer}>
          <span className={style.inputName}>Proposal Note</span>
          <InputItem
            placeholder="Note (optional)"
            className={style.proposalInput}
            onChange={v => this.setNote(v)}
          />
        </div>

        <div>
          <button className={style.genButton} onClick={this.startGenerate}>
            生成交易
          </button>
        </div>

        {this.state.txString ? (
          <div className={style.txContainer}>
            <p>{this.state.txString}</p>
          </div>
        ) : (
          false
        )}

        {this.state.txString ? (
          <div>
            <p><b>使用Nas Nano Pro 扫码</b></p>
            <QRCode value={params} size={150} />
          </div>
        ) : (
          false
        )}

        {this.state.txString ? (
          <div>
            <p><b>使用Nas Wallet Extension</b></p>
            <button className={style.genButton} onClick={this.nebpayAction}>
              发起交易
            </button>
          </div>
        ) : (
          false
        )}
      </div>
    );
  }
}
